var _module = require('../../components/module');
var config = require('config');

_module.service('$listhub', [
    '$log',
    '$window',

    function listhubService($log, $window) {
        $window.lh('init', {
            provider: config.listhub.meterics_provider_id,
            test: config.listhub.test
        });

        return $window.lh;
    }
]);
